export default {"src":"/_next/static/media/faqssvg2.37cfd65b.svg","height":57,"width":70,"blurWidth":0,"blurHeight":0};